<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="기간" cols="2">
        <month-input
          :select-month="selectMonth"
          @updateMonth="updateMonth"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import MonthInput from "@/common/components/input/MonthInput.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LoanPerformanceUploadSearchBar",
  components: {MonthInput, FieldInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      selectMonth: ""
    }
  },
  beforeMount() {
    this.selectMonth = this.getNowMonth();
  },
  methods: {
    search() {
      const params = {
        yyyymm: this.selectMonth.replaceAll("-", "")
      };
      this.$emit("search", params);
    },
    updateMonth(value) {
      this.selectMonth = value;
    }
  }
}
</script>